import { del, get, patch, post } from '../../utils/api'
import { AxiosResponse } from 'axios'

export const fetchModule = (id: string): Promise<AxiosResponse> =>
  get(`/courses/modules/${id}`)

export const fetchModuleScreens = (
  id: string,
  mid: string
): Promise<AxiosResponse> =>
  get(`/courses/courses/${id}/modules/${mid}/module-screens`)

export const editModule = (
  id: string,
  title: string,
  position: number,
  available_at: string
): Promise<AxiosResponse> =>
  patch(`/courses/modules/${id}`, {
    title,
    position,
    available_at,
  })

export const removeModule = (id: string): Promise<AxiosResponse> =>
  del(`/courses/modules/${id}`)

export const createScreen = (
  mid: string,
  title: string,
  typeScreen: 'first' | 'last'
): Promise<AxiosResponse> =>
  post('/courses/module-screens', {
    module_id: mid,
    title,
    type: typeScreen,
  })

export const editScreen = (
  sid: string,
  title: string
): Promise<AxiosResponse> => patch(`/courses/module-screens/${sid}`, { title })

export const removeScreen = (sid: string): Promise<AxiosResponse> =>
  del(`/courses/module-screens/${sid}`)
